import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import config from "../../devprodConfig";
import { mergePdfAttachments } from "./mergePdfAttachments";

export const uploadReportToSharePoint = async ({
  report,
  rakennusData,
  mergedRakennusData,
  assignments,
  ptsContext,
  groupedToimenpiteet,
  fetchLatestRiskidata,
  MakeDocDefinitionFromJson,
  setLoadingPDF,
  setLoadingMessage,
  setLoadingProgress
}) => {
  try {
    setLoadingPDF(true);
    setLoadingMessage("Ladataan SharePointiin...");
    setLoadingProgress(0);

    const latestRiskidata = await fetchLatestRiskidata();

    const { docDefinition, pdfAttachments } = await MakeDocDefinitionFromJson({
      report,
      rakennusData,
      mergedRakennusData,
      assignments,
      riskidata: latestRiskidata,
      groupedToimenpiteet,
      ptsContext
    });

    setLoadingProgress(70);

    const pdfBytes = await new Promise((resolve) =>
      pdfMake.createPdf(docDefinition).getBuffer(resolve)
    );
    const mergedBytes = await mergePdfAttachments(pdfBytes, pdfAttachments);
    const pdfBlob = new Blob([mergedBytes], { type: 'application/pdf' });

    setLoadingProgress(85);

    const folderRes = await axios.get(
      `${config.apiBaseUrl}/sharepoint/folder/by-kiinteisto`,
      {
        params: {
          osoite: rakennusData?.rakennukset_fulls?.[0]?.osoite,
          postinumero: rakennusData?.rakennukset_fulls?.[0]?.postinumero,
          kaupunki: rakennusData?.rakennukset_fulls?.[0]?.toimipaikka,
          kiinteistoId: rakennusData?.id_kiinteisto 
        },
        withCredentials: true
      }
    );

    const { folder } = folderRes.data;

    if (!folder?.id) {
      alert("SharePoint-kansiota ei löytynyt");
      return;
    }

    setLoadingProgress(90);

    const formData = new FormData();

    const filename = `${report?.name || "Raportti"}_${
      rakennusData?.kohteen_nimi || ""
    }.pdf`;

    formData.append("file", pdfBlob, filename);
    formData.append("folderId", folder.id);
    formData.append("isReportUpload", "true");

    await axios.post(
      `${config.apiBaseUrl}/sharepoint/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true
      }
    );

    setLoadingProgress(100);

    alert("✅ Tallennettu SharePointiin!");

  } catch (err) {
    console.error("❌ Upload failed:", err);
    alert("Tallennus epäonnistui");
  } finally {
    setLoadingPDF(false);
  }
};